<template>
<section id="contact" class="inner contact">
      <div class="container-fluid p-0 fullheight">
        <div class="row g-0 fullheight">

          <!-- Contact Section Content Start -->
          <div class="col-12 col-xl-8 inner__content">
            <!-- desktop shadow -->
            <div class="desktop-shadow"></div>
            <!-- inner section blocks -->
            <div class="inner__blocks">

              <!-- Section Container - Section Title Start -->
              <div class="inner__container">
                <div class="content-block">
                  <span class="section__subtitle">Contact</span>
                  <h2>Let's be friends and talk to me.</h2>
                  <p class="section__text">maybe you have a lot of questions about PHP programming, or maybe you need certain services and services?, contact me and I will be happy to help you solve the problem. and more importantly, come be friends with me
                  </p>
                </div>
              </div>
              <!-- Section Container - Section Title End -->

              <!-- Section Container - Contact Data Start -->
              <div class="inner__container">
                <div class="content-block grid-block">
                  <div class="container-fluid px-4">
                    <div class="row gx-5 align-items-stretch">
                      <!-- contact data single item -->
                      <div class="col-12 col-md-6 col-lg-4 contactdata">
                        <div class="contactdata__item contactdata-item-1 block-rounded-l">
                          <div class="contactdata__icon">
                            <img src="https://dummyimage.com/100x100/dedede/636363" alt="Marvio Contact Icon">
                          </div>
                          <h5 class="contactdata__title">Location</h5>
                          <div class="contactdata__descr d-flex align-items-start">
                            <div class="contactdata__icon">
                              <i class="fa-solid fa-location-crosshairs"></i>
                            </div>
                            <div class="contactdata__text">
                              <p><a class="contact-link" href="https://goo.gl/maps/nWXKpGaDPuyH6gxRA" target="_blank">G. Cenda at pesantren Almuhajirin,<br>Koba Bangka Tengah, KEP. Bangka Belitung</a></p>
                            </div>
                          </div>
                          <div class="contactdata__descr d-flex align-items-start">
                            <div class="contactdata__icon">
                              <i class="fa-solid fa-location-crosshairs"></i>
                            </div>
                            <div class="contactdata__text">
                              <p><a class="contact-link" href="https://goo.gl/maps/xap5o3MZBuC6DFHz8" target="_blank">Grimaya<br>Pangkalpinang, KEP. Bangka Belitung</a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- contact data single item -->
                      <div class="col-12 col-md-6 col-lg-4 contactdata">
                        <div class="contactdata__item contactdata-item-2 block-rounded-l">
                          <div class="contactdata__icon">
                            <img src="https://dummyimage.com/100x100/dedede/636363" alt="Marvio Contact Icon">
                          </div>
                          <h5 class="contactdata__title">Follow us</h5>
                          <div class="contactdata__descr d-flex align-items-start">
                            <ul class="contactdata__socials">
                              <li>
                                <i class="fa-brands fa-facebook"></i>
                                <a class="contact-link" href="https://www.facebook.com/" target="_blank">Facebook</a>
                              </li>
                              <li>
                                <i class="fa-brands fa-instagram"></i>
                                <a class="contact-link" href="https://www.instagram.com/bofoiii._" target="_blank">Instagram</a>
                              </li>
                              <li>
                                <i class="fa-brands fa-twitter"></i>
                                <a class="contact-link" href="https://twitter.com/" target="_blank">Twitter</a>
                              </li>
                              <li>
                                <i class="fa-brands fa-pinterest"></i>
                                <a class="contact-link" href="https://pinterest.com/" target="_blank">Pinterest</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- contact data single item -->
                      <div class="col-12 col-md-6 col-lg-4 contactdata">
                        <div class="contactdata__item contactdata-item-3 block-rounded-l">
                          <div class="contactdata__icon">
                            <img src="https://dummyimage.com/100x100/dedede/636363" alt="Marvio Contact Icon">
                          </div>
                          <h5 class="contactdata__title">Contact</h5>
                          <div class="contactdata__descr d-flex align-items-start">
                            <div class="contactdata__icon">
                              <i class="fa-solid fa-phone"></i>
                            </div>
                            <div class="contactdata__text">
                              <p>
                                <a class="contact-link" href="tel:+6282182114366">+62 821-8211-4366</a>
                              </p>
                            </div>
                          </div>
                          <div class="contactdata__descr d-flex align-items-start">
                            <div class="contactdata__icon">
                              <i class="fa-solid fa-envelope"></i>
                            </div>
                            <div class="contactdata__text">
                              <a class="contact-link" href="mailto:riskirahmand0@gmail.com?subject=Message%20from%20your%20site">riskirahmand0@gmail.com</a>
                              <br>
                              <a class="contact-link" href="mailto:riskirahmand0@gmail.com?subject=Message%20from%20your%20site">riskirahmand0@gmail.com</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Section Container - Contact Data End -->

              <!-- Section Container - Contact Form Start -->
              <div class="inner__container">
                <div class="content-block">
                  <h3>Just say hello!</h3>
                  <p class="block__text">Want to know more about me, tell me about your project or just to say hello?
                    Drop me a line and I'll get back as soon as possible.
                  </p>
                </div>
                <div class="content-block grid-block">
                  <div class="form-container">

                    <!-- Contact Form Reply Group Start -->
                    <div class="reply-group">
                      <i class="fa-solid fa-circle-check reply-group__icon"></i>
                      <p class="reply-group__title light">Done!</p>
                      <span class="reply-group__text light">Thanks for your message. We will get back as soon as possible</span>
                    </div>
                    <!-- Contact Form Reply Group End -->

                    <!-- Contact Form Start -->
                    <form class="form form-light contact-form" id="contact-form">
                      <!-- Hidden Required Fields -->
                      <input type="hidden" name="project_name" value="Marvio - Coming Soon & Portfolio Template">
                      <input type="hidden" name="admin_email" value="support@mixdesign.club">
                      <input type="hidden" name="form_subject" value="Contact Form Message">
                      <!-- END Hidden Required Fields-->
                      <div class="container-fluid px-4">
                        <div class="row gx-5">
                          <div class="col-12 col-md-6">
                            <input class="block-rounded-s" type="text" name="Name" placeholder="Your Name*" required>
                          </div>
                          <div class="col-12 col-md-6">
                            <input class="block-rounded-s" type="text" name="Company" placeholder="Company Name">
                          </div>
                          <div class="col-12 col-md-6">
                            <input class="block-rounded-s" type="email" name="E-mail" placeholder="Email Adress*" required>
                          </div>
                          <div class="col-12 col-md-6">
                            <input class="block-rounded-s" type="tel" name="Phone" placeholder="Phone Number*" required>
                          </div>
                          <div class="col-12">
                            <textarea class="block-rounded-s margin-s" name="Message" placeholder="A Few Words*" required></textarea>
                          </div>
                          <div class="col-12">
                            <span class="inputs-description">*Required fields</span>
                            <button class="btn btn-l btn-light hover-gradient hover-gradient-l" type="submit">
                              <em></em>
                              <span class="btn-caption">Submit</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <!-- Contact Form End  -->

                  </div>
                </div>
              </div>
              <!-- Section Container - Contact Form End -->

            </div>
          </div>
          <!-- Contact Section Content End -->

          <!-- Contact Section Media Start -->
          <div class="col-12 col-xl-4 inner__media">

            <!-- Contact Section Image Background Start -->
            <div class="image media-image-contact"></div>
            <!-- Contact Section Image Background End -->

          </div>
          <!-- Contact Section Media End -->

        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "ContactSection"
}
</script>